const LookupUrl = ({ value, label }) => {
    if (!value) return '—';
    try {
        const url = new URL(value);
        if (['https:', 'http:'].includes(url.protocol)) return <a href={url.href} title={value} target="_blank" rel="noopener noreferrer">{label}</a>;
    } catch { /* Keep legacy non-URL values readable without creating unsafe links. */ }
    return <span>{value}</span>;
};
export default LookupUrl;
